import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { notesStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderDetailsNotes";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

notesStyles.notesText = mergeToNew(notesStyles.notesText, {
    css: css`
        padding: 6px;
        display: flex;

        @media print {
            display: flex;
        }
    `,
});
notesStyles.wrapper = mergeToNew(notesStyles.wrapper, {
    width: [12, 12, 6, 6, 6],
    css: css`
        display: flex;
        flex-direction: column;
        padding: 0px 8px 0px 0px;
    `,
});

notesStyles.titleText = mergeToNew(notesStyles.titleText, {
    variant: "h3",
    css: css`
        margin-bottom: 0px;
        background: ${themeBackgrounds.lightGray};
        padding: 16px;
        width: 100%;
    `,
});
